import FileNodeRow from './FileNodeRow.component';

export default FileNodeRow;